export default __webpack_public_path__ + "static/media/4.e63a5371.png";